module.exports = __webpack_public_path__ + "static/media/main idea.590aad44.mp3";